import script from "./FissionColorRow.vue?vue&type=script&setup=true&lang=js"
export * from "./FissionColorRow.vue?vue&type=script&setup=true&lang=js"

import "./FissionColorRow.vue?vue&type=style&index=0&id=2084d5a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2084d5a5"]])

export default __exports__